import React from 'react';
import Card from '../../ui/Card';
import { TrendingUpIcon, TrendingDownIcon, SearchIcon, FileTextIcon } from 'lucide-react';
const KeywordsLandingPagesTable: React.FC = () => {
  const keywords = [{
    keyword: 'automotive LED headlamps India',
    impressions: 48500,
    clicks: 2425,
    ctr: 5.0,
    avgPosition: 2.3,
    conversions: 142,
    conversionRate: 5.9,
    trend: 'up'
  }, {
    keyword: 'EV battery components supplier',
    impressions: 38200,
    clicks: 1910,
    ctr: 5.0,
    avgPosition: 3.1,
    conversions: 118,
    conversionRate: 6.2,
    trend: 'up'
  }, {
    keyword: 'car lighting manufacturer',
    impressions: 52800,
    clicks: 2112,
    ctr: 4.0,
    avgPosition: 4.2,
    conversions: 98,
    conversionRate: 4.6,
    trend: 'stable'
  }, {
    keyword: 'automotive plastic parts',
    impressions: 44600,
    clicks: 1784,
    ctr: 4.0,
    avgPosition: 3.8,
    conversions: 85,
    conversionRate: 4.8,
    trend: 'up'
  }, {
    keyword: 'OEM auto components India',
    impressions: 35400,
    clicks: 1062,
    ctr: 3.0,
    avgPosition: 5.1,
    conversions: 68,
    conversionRate: 6.4,
    trend: 'down'
  }];
  const landingPages = [{
    page: '/products/led-headlamps',
    visits: 28450,
    bounceRate: 38.2,
    avgTime: 4.2,
    conversions: 485,
    conversionRate: 1.7,
    revenue: 142,
    trend: 'up'
  }, {
    page: '/ev-components/battery-systems',
    visits: 24680,
    bounceRate: 35.8,
    avgTime: 4.8,
    conversions: 428,
    conversionRate: 1.7,
    revenue: 138,
    trend: 'up'
  }, {
    page: '/solutions/automotive-lighting',
    visits: 22150,
    bounceRate: 41.5,
    avgTime: 3.9,
    conversions: 368,
    conversionRate: 1.7,
    revenue: 118,
    trend: 'stable'
  }, {
    page: '/products/polymer-components',
    visits: 18920,
    bounceRate: 44.2,
    avgTime: 3.5,
    conversions: 298,
    conversionRate: 1.6,
    revenue: 95,
    trend: 'up'
  }, {
    page: '/oem-partnerships',
    visits: 16540,
    bounceRate: 39.8,
    avgTime: 4.5,
    conversions: 285,
    conversionRate: 1.7,
    revenue: 88,
    trend: 'down'
  }];
  const getTrendIcon = (trend: string) => {
    if (trend === 'up') return <TrendingUpIcon size={14} className="text-green-600" data-id="element-7481" />;
    if (trend === 'down') return <TrendingDownIcon size={14} className="text-red-600" data-id="element-7482" />;
    return <span className="text-gray-400" data-id="element-7483">—</span>;
  };
  const getPositionColor = (position: number) => {
    if (position <= 3) return 'text-green-600 font-bold';
    if (position <= 5) return 'text-yellow-600 font-semibold';
    return 'text-gray-600';
  };
  const getBounceRateColor = (rate: number) => {
    if (rate < 40) return 'text-green-600';
    if (rate < 50) return 'text-yellow-600';
    return 'text-red-600';
  };
  return <div className="space-y-8" data-id="element-7484">
      {/* Keywords Table */}
      <Card className="p-6" data-id="element-7485">
        <div className="flex items-center mb-4" data-id="element-7486">
          <SearchIcon size={20} className="text-blue-600 mr-2" data-id="element-7487" />
          <div data-id="element-7488">
            <h3 className="text-lg font-semibold text-gray-800" data-id="element-7489">
              Top Performing Keywords
            </h3>
            <p className="text-sm text-gray-600" data-id="element-7490">
              SEO and paid search keyword performance
            </p>
          </div>
        </div>
        <div className="overflow-x-auto" data-id="element-7491">
          <table className="w-full" data-id="element-7492">
            <thead data-id="element-7493">
              <tr className="border-b-2 border-gray-300" data-id="element-7494">
                <th className="text-left py-3 px-4 text-sm font-bold text-gray-700" data-id="element-7495">
                  Keyword
                </th>
                <th className="text-right py-3 px-4 text-sm font-bold text-gray-700" data-id="element-7496">
                  Impressions
                </th>
                <th className="text-right py-3 px-4 text-sm font-bold text-gray-700" data-id="element-7497">
                  Clicks
                </th>
                <th className="text-right py-3 px-4 text-sm font-bold text-gray-700" data-id="element-7498">
                  CTR %
                </th>
                <th className="text-center py-3 px-4 text-sm font-bold text-gray-700" data-id="element-7499">
                  Avg Position
                </th>
                <th className="text-right py-3 px-4 text-sm font-bold text-gray-700" data-id="element-7500">
                  Conversions
                </th>
                <th className="text-right py-3 px-4 text-sm font-bold text-gray-700" data-id="element-7501">
                  Conv. Rate
                </th>
                <th className="text-center py-3 px-4 text-sm font-bold text-gray-700" data-id="element-7502">
                  Trend
                </th>
              </tr>
            </thead>
            <tbody data-id="element-7503">
              {keywords.map((keyword, index) => <tr key={index} className="border-b border-gray-100 hover:bg-gray-50" data-id="element-7504">
                  <td className="py-3 px-4 text-sm text-gray-800" data-id="element-7505">
                    {keyword.keyword}
                  </td>
                  <td className="py-3 px-4 text-sm text-right text-gray-700" data-id="element-7506">
                    {keyword.impressions.toLocaleString()}
                  </td>
                  <td className="py-3 px-4 text-sm text-right text-gray-700" data-id="element-7507">
                    {keyword.clicks.toLocaleString()}
                  </td>
                  <td className="py-3 px-4 text-sm text-right text-gray-700" data-id="element-7508">
                    {keyword.ctr.toFixed(1)}%
                  </td>
                  <td className="py-3 px-4 text-center" data-id="element-7509">
                    <span className={`text-sm ${getPositionColor(keyword.avgPosition)}`} data-id="element-7510">
                      #{keyword.avgPosition.toFixed(1)}
                    </span>
                  </td>
                  <td className="py-3 px-4 text-sm text-right font-medium text-gray-800" data-id="element-7511">
                    {keyword.conversions}
                  </td>
                  <td className="py-3 px-4 text-sm text-right font-semibold text-green-600" data-id="element-7512">
                    {keyword.conversionRate.toFixed(1)}%
                  </td>
                  <td className="py-3 px-4 text-center" data-id="element-7513">
                    {getTrendIcon(keyword.trend)}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
        <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-7514">
          <div className="grid grid-cols-4 gap-4 text-sm" data-id="element-7515">
            <div className="text-center" data-id="element-7516">
              <div className="text-gray-600" data-id="element-7517">Total Impressions</div>
              <div className="text-xl font-bold text-gray-900" data-id="element-7518">
                {keywords.reduce((sum, k) => sum + k.impressions, 0).toLocaleString()}
              </div>
            </div>
            <div className="text-center" data-id="element-7519">
              <div className="text-gray-600" data-id="element-7520">Total Clicks</div>
              <div className="text-xl font-bold text-blue-600" data-id="element-7521">
                {keywords.reduce((sum, k) => sum + k.clicks, 0).toLocaleString()}
              </div>
            </div>
            <div className="text-center" data-id="element-7522">
              <div className="text-gray-600" data-id="element-7523">Total Conversions</div>
              <div className="text-xl font-bold text-green-600" data-id="element-7524">
                {keywords.reduce((sum, k) => sum + k.conversions, 0)}
              </div>
            </div>
            <div className="text-center" data-id="element-7525">
              <div className="text-gray-600" data-id="element-7526">Avg CTR</div>
              <div className="text-xl font-bold text-purple-600" data-id="element-7527">
                {(keywords.reduce((sum, k) => sum + k.clicks, 0) / keywords.reduce((sum, k) => sum + k.impressions, 0) * 100).toFixed(1)}
                %
              </div>
            </div>
          </div>
        </div>
      </Card>
      {/* Landing Pages Table */}
      <Card className="p-6" data-id="element-7528">
        <div className="flex items-center mb-4" data-id="element-7529">
          <FileTextIcon size={20} className="text-green-600 mr-2" data-id="element-7530" />
          <div data-id="element-7531">
            <h3 className="text-lg font-semibold text-gray-800" data-id="element-7532">
              Top Performing Landing Pages
            </h3>
            <p className="text-sm text-gray-600" data-id="element-7533">
              Page performance and conversion metrics
            </p>
          </div>
        </div>
        <div className="overflow-x-auto" data-id="element-7534">
          <table className="w-full" data-id="element-7535">
            <thead data-id="element-7536">
              <tr className="border-b-2 border-gray-300" data-id="element-7537">
                <th className="text-left py-3 px-4 text-sm font-bold text-gray-700" data-id="element-7538">
                  Landing Page
                </th>
                <th className="text-right py-3 px-4 text-sm font-bold text-gray-700" data-id="element-7539">
                  Visits
                </th>
                <th className="text-right py-3 px-4 text-sm font-bold text-gray-700" data-id="element-7540">
                  Bounce Rate
                </th>
                <th className="text-right py-3 px-4 text-sm font-bold text-gray-700" data-id="element-7541">
                  Avg Time
                </th>
                <th className="text-right py-3 px-4 text-sm font-bold text-gray-700" data-id="element-7542">
                  Conversions
                </th>
                <th className="text-right py-3 px-4 text-sm font-bold text-gray-700" data-id="element-7543">
                  Conv. Rate
                </th>
                <th className="text-right py-3 px-4 text-sm font-bold text-gray-700" data-id="element-7544">
                  Revenue (₹L)
                </th>
                <th className="text-center py-3 px-4 text-sm font-bold text-gray-700" data-id="element-7545">
                  Trend
                </th>
              </tr>
            </thead>
            <tbody data-id="element-7546">
              {landingPages.map((page, index) => <tr key={index} className="border-b border-gray-100 hover:bg-gray-50" data-id="element-7547">
                  <td className="py-3 px-4 text-sm font-medium text-blue-600" data-id="element-7548">
                    {page.page}
                  </td>
                  <td className="py-3 px-4 text-sm text-right text-gray-700" data-id="element-7549">
                    {page.visits.toLocaleString()}
                  </td>
                  <td className="py-3 px-4 text-right" data-id="element-7550">
                    <span className={`text-sm font-semibold ${getBounceRateColor(page.bounceRate)}`} data-id="element-7551">
                      {page.bounceRate.toFixed(1)}%
                    </span>
                  </td>
                  <td className="py-3 px-4 text-sm text-right text-gray-700" data-id="element-7552">
                    {page.avgTime.toFixed(1)} min
                  </td>
                  <td className="py-3 px-4 text-sm text-right font-medium text-gray-800" data-id="element-7553">
                    {page.conversions}
                  </td>
                  <td className="py-3 px-4 text-sm text-right font-semibold text-green-600" data-id="element-7554">
                    {page.conversionRate.toFixed(1)}%
                  </td>
                  <td className="py-3 px-4 text-sm text-right font-bold text-gray-900" data-id="element-7555">
                    ₹{page.revenue}L
                  </td>
                  <td className="py-3 px-4 text-center" data-id="element-7556">
                    {getTrendIcon(page.trend)}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
        <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-7557">
          <div className="grid grid-cols-5 gap-4 text-sm" data-id="element-7558">
            <div className="text-center" data-id="element-7559">
              <div className="text-gray-600" data-id="element-7560">Total Visits</div>
              <div className="text-xl font-bold text-gray-900" data-id="element-7561">
                {landingPages.reduce((sum, p) => sum + p.visits, 0).toLocaleString()}
              </div>
            </div>
            <div className="text-center" data-id="element-7562">
              <div className="text-gray-600" data-id="element-7563">Avg Bounce Rate</div>
              <div className="text-xl font-bold text-yellow-600" data-id="element-7564">
                {(landingPages.reduce((sum, p) => sum + p.bounceRate, 0) / landingPages.length).toFixed(1)}
                %
              </div>
            </div>
            <div className="text-center" data-id="element-7565">
              <div className="text-gray-600" data-id="element-7566">Total Conversions</div>
              <div className="text-xl font-bold text-green-600" data-id="element-7567">
                {landingPages.reduce((sum, p) => sum + p.conversions, 0)}
              </div>
            </div>
            <div className="text-center" data-id="element-7568">
              <div className="text-gray-600" data-id="element-7569">Avg Conv. Rate</div>
              <div className="text-xl font-bold text-purple-600" data-id="element-7570">
                {(landingPages.reduce((sum, p) => sum + p.conversions, 0) / landingPages.reduce((sum, p) => sum + p.visits, 0) * 100).toFixed(2)}
                %
              </div>
            </div>
            <div className="text-center" data-id="element-7571">
              <div className="text-gray-600" data-id="element-7572">Total Revenue</div>
              <div className="text-xl font-bold text-blue-600" data-id="element-7573">
                ₹{landingPages.reduce((sum, p) => sum + p.revenue, 0)}L
              </div>
            </div>
          </div>
        </div>
      </Card>
    </div>;
};
export default KeywordsLandingPagesTable;